import { Button } from '@/components/ui/Button/Button';
import { ComboClearButton } from '@/components/ui/ComboClearButton/ComboClearButton';
import './ReaderCatalogPricePositionsEditor.css';

/** Совпадает с MAX_READER_PRICES_PER_READER на сервере */
export const MAX_READER_CATALOG_PRICE_POSITIONS = 40;

export interface ReaderCatalogPriceDraftRow {
  id?: string;
  price_name: string;
  /** Сырое значение суммы в поле ввода */
  price: string;
}

export interface ReaderCatalogPricePositionsEditorProps {
  value: ReaderCatalogPriceDraftRow[];
  onChange: (next: ReaderCatalogPriceDraftRow[]) => void;
  disabled?: boolean;
  maxRows?: number;
  /** aria-label контейнера списка строк */
  ariaLabel?: string;
}

export function ReaderCatalogPricePositionsEditor({
  value,
  onChange,
  disabled = false,
  maxRows = MAX_READER_CATALOG_PRICE_POSITIONS,
  ariaLabel = 'Позиции стоимости чтеца',
}: ReaderCatalogPricePositionsEditorProps) {
  const updateRow = (index: number, patch: Partial<ReaderCatalogPriceDraftRow>) => {
    onChange(value.map((row, i) => (i === index ? { ...row, ...patch } : row)));
  };

  const removeRow = (index: number) => {
    onChange(value.filter((_, i) => i !== index));
  };

  const addRow = () => {
    if (value.length >= maxRows) return;
    onChange([...value, { price_name: '', price: '' }]);
  };

  return (
    <div className="reader-catalog-price-positions-editor" aria-label={ariaLabel}>
      {value.map((item, index) => (
        <div key={index} className="reader-catalog-price-positions-editor__row">
          <div
            className={`reader-catalog-price-positions-editor__name ${
              !disabled ? 'reader-catalog-price-positions-editor__name_has-clear' : ''
            }`.trim()}
          >
            <input
              className="reader-catalog-price-positions-editor__name-input"
              type="text"
              value={item.price_name}
              onChange={(e) => updateRow(index, { price_name: e.target.value })}
              disabled={disabled}
              placeholder="Название услуги"
              autoComplete="off"
            />
            {!disabled ? (
              <ComboClearButton
                aria-label="Удалить позицию цены"
                onClick={() => removeRow(index)}
              />
            ) : null}
          </div>
          <div className="reader-catalog-price-positions-editor__amount">
            <input
              className="reader-catalog-price-positions-editor__amount-input"
              type="text"
              inputMode="decimal"
              value={item.price}
              onChange={(e) => updateRow(index, { price: e.target.value })}
              disabled={disabled}
              placeholder="Стоимость"
              title="Стоимость в рублях"
              autoComplete="off"
            />
            <span className="reader-catalog-price-positions-editor__ruble" aria-hidden="true">
              ₽
            </span>
          </div>
        </div>
      ))}
      <Button
        type="button"
        size="m"
        variant="primary"
        fullWidth
        className="reader-catalog-price-positions-editor__add"
        title={value.length >= maxRows ? `Не больше ${maxRows} позиций у чтеца` : undefined}
        onClick={addRow}
        disabled={disabled || value.length >= maxRows}
      >
        Добавить цену
      </Button>
    </div>
  );
}
